jQuery(function ($) {
    $(document).ready(function () {
        $('.store__list-link--mobile').click( function (btn) {
            btn.preventDefault();

            $brother = $(this).next();

            if ($brother.hasClass('dropdown-active')) {
                $brother.removeClass('dropdown-active');
                $(this).removeClass('store__list-link--mobile-active');
            } else {
                $('.nav-dropdown__footer').each( function() {
                    $(this).removeClass('dropdown-active');
                });
                $('.store__list-link--mobile').each(function() {
                    $(this).removeClass('store__list-link--mobile-active');
                });
                
                $brother.addClass('dropdown-active');
                $(this).addClass('store__list-link--mobile-active');
            }
            
        });

        $('.modal--newsletter').attr('aria-hidden','true');

        $('.button-variant__close').click( function(e) {
            e.preventDefault();
            $('.product-form__button-variant').removeClass('button-variant__active');
            $('.product-form__variants').removeClass('product-form__variants-active');
        });

        $('.button-variant').click(function(e) {
            e.preventDefault();
            $(this).parent().addClass('button-variant__active');
            $('.product-form__variants').addClass('product-form__variants-active');
        });

        $('.button__cart--close').click( function(e) {
            e.preventDefault();            
        });

        if ($('.popup-newsletter__form-success').length) {
            if ( window.location.pathname == '/' ){
                $('.modal--newsletter').attr('aria-hidden','false');
            }
            $('.modal__dialog-success').addClass('modal__dialog-newsletter--active');
        } else {
            $('.modal__dialog-newsletter').addClass('modal__dialog-newsletter--active');
        }

        $('.announcement-bar__button').click(function (e) {
            $('.modal--newsletter').attr('aria-hidden','false');
        });

        $('.popup-newsletter__close').click(function(e) {
            $('.modal--newsletter').attr('aria-hidden','true');
        });

        $('.expandable-content__toggle').click( function (e) {
            if ($(this).hasClass('toogle-active')) {
                $(this).removeClass('toogle-active');
            } else {
                $(this).addClass('toogle-active');
            }
        });

        $('.footer__link-item--dropdown').click( function (btn) {
            btn.preventDefault();

            $brother = $(this).next();

            if ($brother.hasClass('dropdown-active')) {
                $brother.removeClass('dropdown-active');
                $(this).removeClass('footer__link-item--dropdown-active');
            } else {
                $('.nav-dropdown__footer').each( function() {
                    $(this).removeClass('dropdown-active');
                });
                $('.footer__link-item--dropdown').each(function() {
                    $(this).removeClass('footer__link-item--dropdown-active');
                });
                
                $brother.addClass('dropdown-active');
                $(this).addClass('footer__link-item--dropdown-active');
            }
            
        });
    })
});